module.exports = __webpack_public_path__ + "assets/images/base_roads_phase5.7db836fb5d7880e705a48d0f77a21460.svg";